import React from 'react';
import { TextField } from '@material-ui/core';
import { Control, Controller, FieldPath } from 'react-hook-form';
import { EditableQuestion } from '../../../../../types';

interface Props {
  control: Control<EditableQuestion>;
  name: FieldPath<EditableQuestion>;
  placeholder: string;
}

/**
 * The api validates decimals, min and max as numbers, so an empty box has to clear the
 * value rather than save the empty string a text input would otherwise hand over.
 */
const NumericLimitEditor = ({ control, name, placeholder }: Props) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { onChange, ref, value, ...restField } }) => (
      <TextField
        inputRef={ref}
        {...restField}
        value={value ?? ''}
        type="number"
        placeholder={placeholder}
        onChange={event => onChange(event.target.value === '' ? undefined : Number(event.target.value))}
      />
    )}
  />
);

export default NumericLimitEditor;
